var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Styles } from "@brushfire/ui";
import { CardElement } from "@stripe/react-stripe-js";
import { useContext } from "react";
import { getPaymentMethodId } from "../../../data/helpers";
import { WidgetContext } from "../../Widget";
import { useDispatch, useSelector } from "react-redux";
import { clearInlineErrors } from "../../../store/AppState/actions";
var useTypedSelector = useSelector;
var Stripe = function (_a) {
    var id = _a.id, label = _a.label, setPaymentMethodId = _a.setPaymentMethodId, setError = _a.setError, setStripeCardReady = _a.setStripeCardReady;
    var darkMode = useContext(WidgetContext).darkMode;
    var dispatch = useDispatch();
    var inlineErrors = useTypedSelector(function (store) { return store.app.inlineErrors; });
    return (_jsxs("div", __assign({ className: "field" }, { children: [_jsx("label", __assign({ htmlFor: id }, { children: label })), _jsx(CardElement, { id: id, className: (inlineErrors === null || inlineErrors === void 0 ? void 0 : inlineErrors.stripePaymentError) ? "stripe-field has-error" : "", options: {
                    style: {
                        base: {
                            color: (inlineErrors === null || inlineErrors === void 0 ? void 0 : inlineErrors.stripePaymentError)
                                ? Styles.error
                                : darkMode
                                    ? Styles.white
                                    : Styles.black,
                            "::placeholder": {
                                color: darkMode ? Styles.placeholderColorDark : Styles.placeholderColor,
                            },
                            ":-webkit-autofill": {
                                color: (inlineErrors === null || inlineErrors === void 0 ? void 0 : inlineErrors.stripePaymentError)
                                    ? Styles.error
                                    : darkMode
                                        ? Styles.white
                                        : Styles.black,
                            },
                            fontFamily: "ff-basic-gothic-pro, sans-serif",
                        },
                        invalid: {
                            color: Styles.error,
                        },
                    },
                    classes: {
                        base: "stripe-field",
                        empty: "stripe-field empty",
                        invalid: "stripe-field has-error",
                        focus: "stripe-field focus",
                    },
                    hidePostalCode: true,
                }, onChange: function (evt) {
                    var _a;
                    if (inlineErrors === null || inlineErrors === void 0 ? void 0 : inlineErrors.stripePaymentError) {
                        dispatch(clearInlineErrors());
                    }
                    getPaymentMethodId((_a = evt.brand) !== null && _a !== void 0 ? _a : "")
                        .then(function (paymentMethodId) {
                        setPaymentMethodId(paymentMethodId);
                    })
                        .catch(function (err) {
                        if (evt.complete) {
                            setError(err);
                        }
                    });
                }, onReady: function () {
                    setStripeCardReady(true);
                } }), (inlineErrors === null || inlineErrors === void 0 ? void 0 : inlineErrors.stripePaymentError) && _jsx("span", __assign({ className: "error" }, { children: inlineErrors.stripePaymentError }))] })));
};
export default Stripe;
